import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { ProblemSection } from './sections/ProblemSection';
import { SolutionSection } from './sections/SolutionSection';
import { PricingSection } from './sections/PricingSection';
import { TrustSection } from './sections/TrustSection';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { FloatingBanner } from './components/FloatingBanner';
export function App() {
  return <div className="w-full min-h-screen" style={{
    backgroundColor: '#0A0A0A'
  }} data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <PricingSection data-id="element-5" />
      <TrustSection data-id="element-6" />
      <Footer data-id="element-7" />
      <FloatingBanner data-id="element-8" />
    </div>;
}